<template>
  <div class="depositActionsWrapper">

    <div class="deposit-store__info_wrapper">
      <v-card v-if="getStoredDeposits > 0" :class="['deposit-store__info', getStoredTourData > 0 ? 'no-border' : '']" @click="navigateToSavedDeposits">
        <span>Du hast {{ getStoredDeposits }} Pfandrückgabe(n) im Zwischenspeicher</span>
      </v-card>
      <v-card v-if="getStoredTourData > 0" :class="[getStoredDeposits > 0 ? 'deposit-store__info_2' : 'deposit-store__info']" @click="navigateToSavedTourData">
        <span>Du hast {{ getStoredTourData }} Aufträge für Tour-Daten im Zwischenspeicher</span>
      </v-card>
    </div>

    <div style="padding-top: 150px;">
      <v-card class="depositActionsCard" @click.stop="startBottleDepositList">
        <span>Pfandrückgabe starten</span>
        <Component :is="require('@/assets/deposit_icon.svg')"/>
      </v-card>

      <v-card class="depositActionsCard" @click.stop="openTourPlan">
        <span>Tourenplan</span>
        <Component :is="require('@/assets/tour.svg')"/>
      </v-card>
    </div>

    <v-dialog v-model="this.depositStartCheck" persistent content-class="depositStartOption">
      <v-card class="marketWrapper">
        <v-container>
            <v-card-text class="textSize__16">
              Deine zuletzt angelegte Rückgabe von Pfandartikeln wurde noch nicht abgeschlossen.
              <br>
              <br>
              Möchtest Du diese löschen und eine neue Rückgabe starten oder mit der begonnenen Rückgabe fortfahren?
            </v-card-text>
          <v-btn  @click="depositReset = true"
                  class="depositResetBtn">
            Neue Rückgabe
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn  @click="depositReset = false"
                  class="depositContBtn">
            Fortfahren
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import router from '@/router'
import {mapActions, mapMutations, mapState} from "vuex";
import axios from "axios";

export default {
  components: {},
  data:() => {
    return {
      depositStart: false,
      depositReset: null,
    }
  },

  name: "depositActions",

  methods: {
    ...mapActions({
      setHeaderVisibility: 'setHeaderVisibility'
    }),

    ...mapMutations({
      setContinuedDeposit: 'setContinuedDeposit',
      setDepositStartCheck: 'setDepositStartCheck',
      setDepositReset: 'setDepositReset'
    }),

    navigateToSavedDeposits() {
      router.push({name: 'savedDeposits'})
    },

    navigateToSavedTourData() {
      router.push({name: 'savedTourData'})
    },

    startBottleDepositScanner() {
      if(localStorage.getItem('currentDeposit')) {
        this.depositStart = true
      }
      else {
        this.setDepositStartCheck(false)
        router.push({name: 'bottleDeposit'})
      }
    },

    openTourPlan() {
      router.push({name:'weeklyTourData'})
    },

    startBottleDepositList() {
      if(localStorage.getItem('currentDeposit')) {
        this.setDepositStartCheck(true)
      }
      else {
        this.setDepositStartCheck(false)
        router.push({name:'bottleDepositList'})
      }
    },
  },

  computed: {
    ...mapState({
      depositStartCheck: 'depositStartCheck',
    }),

    getStoredDeposits() {
      if(localStorage.getItem('savedDeposits') !== null) {
        let storedDeposits = JSON.parse(localStorage.getItem('savedDeposits'))
        return storedDeposits.length
      }
      else {
        return 0
      }
    },

    getStoredTourData() {
      if(localStorage.getItem('currentSignaturesTourData') !== null) {
        let storedTourData = JSON.parse(localStorage.getItem('currentSignaturesTourData'))
        const keys = Object.keys(storedTourData)
        return keys.length
      }
      else {
        return 0
      }
    }
  },

  mounted() {
    this.setHeaderVisibility(false)

    window.addEventListener("offline", () => {
      this.onlineState = false
    })
    window.addEventListener("online", () => {
      this.onlineState = true
    })

    //pre-Check if offline or online
    this.onlineState = window.navigator.onLine

    if(this.onlineState) {
      //Fetch markets for offline use
      axios.post('/api/searchCustomer')
          .then((result) => {
            localStorage.setItem('customers', JSON.stringify(result.data))
          })
          .catch(function() {

          })

      //Fetch depositValues for offline usage
      axios.get('/api/getDeposits')
          .then((result) => {
            this.depositValues = result.data
            localStorage.setItem('depositValues', JSON.stringify(result.data))
          })
          .catch(function() {

          })
    }
  },

  watch: {
    depositReset(val) {
      if(val) {
        localStorage.setItem('currentDeposit', '{}')
        this.setContinuedDeposit(false)
        router.push({name:'bottleDepositList'})
        this.setDepositStartCheck(false)
      }
      else {
        this.setContinuedDeposit(true)
        router.push({name:'bottleDepositList'})
        this.setDepositStartCheck(false)
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.setHeaderVisibility(false)
    })
  }
}
</script>

<style>
  .deposit-store__info_wrapper {
    position: absolute;
    width: 100%;
  }
  .deposit-store__info {
    width: 100%;
    border-radius: 0px 0px 24px 24px!important;
    padding: 15px 0px 15px 0px;
    background-color: rgba(0, 0, 0, 0.35) !important;
  }
  .deposit-store__info.no-border {
    border-radius: 0px!important;
  }
  .deposit-store__info_2 {
    width: 100%;
    border-radius: 0px 0px 24px 24px!important;
    padding: 15px 0px 15px 0px;
    background-color: rgba(0, 0, 0, 0.65) !important;
  }

  .deposit-store__info span,
  .deposit-store__info_2 span {
    color: white;
  }

  .deposit-store__info,
  .deposit-store__info_2 {
    padding-left: 10px;
    padding-right: 10px;
  }
</style>
